import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';
import { focusOutline } from './page-primitives';
const Root = styled(ButtonBase, {
    shouldForwardProp: prop => prop !== 'isSelected'
})(({ theme, isSelected }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '0.5rem',
    width: '100%',
    textAlign: 'left',
    padding: '0.4375rem 0.625rem',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    fontSize: '0.8125rem',
    fontWeight: isSelected ? 600 : 400,
    color: isSelected ? theme.palette.secondary.light : theme.palette.text.secondary,
    backgroundColor: isSelected ? theme.palette.accentSoft : 'transparent',
    marginBottom: '1px',
    fontFamily: 'inherit',
    transition: 'background 0.14s, color 0.14s',
    '&:hover': isSelected
        ? {}
        : {
            backgroundColor: theme.palette.surface3,
            color: theme.palette.text.primary
        },
    ...focusOutline(theme)
}));
export const CategoryListItem = ({ label, icon: Icon, isSelected, onClick }) => (_jsxs(Root, { isSelected: isSelected, "aria-current": isSelected ? 'true' : undefined, onClick: onClick, children: [_jsx(Icon, { sx: { fontSize: '0.9375rem', opacity: 0.75, flexShrink: 0 } }), label] }));
//# sourceMappingURL=category-list-item.js.map